import { findTheCountOfDisabledAttributeNames } from 'parser/filterParser';
import { off } from 'process';
import React from 'react';

interface props {
    allCheckedAttribute: any;
    allAttributeNames: any;
    allCount: number;
    allSelectedValueForAllAttribute: any;
    attributeType: any;
    searchLength: any;
}

function FilterSelectionCount({
    allCheckedAttribute,
    allAttributeNames,
    allCount,
    allSelectedValueForAllAttribute,
    attributeType,
    searchLength,
}: props) {
    function countSelection(allCheckedAttribute: any, allAttributeNames: any) {
        let countPresentInTheAllCheckList = 0;
        for (let attr of allAttributeNames) {
            if (attr.attributeExId in allCheckedAttribute) {
                countPresentInTheAllCheckList++;
            }
        }
        if (allCheckedAttribute) {
            let disabledCount = findTheCountOfDisabledAttributeNames(allAttributeNames);
            if (!searchLength) {
                if (allSelectedValueForAllAttribute[attributeType]) {
                    return allCount - (allAttributeNames?.length - countPresentInTheAllCheckList - disabledCount);
                } else {
                    return Object.keys(allCheckedAttribute)?.length;
                }
            } else {
                return countPresentInTheAllCheckList;
            }
        }
    }
    return (
        <>
            {allCheckedAttribute && Object.keys(allCheckedAttribute)?.length > 0 && (
                <span className="w-fit flex justify-center items-center bg-purpleFont text-white rounded-sm px-1">
                    {countSelection(allCheckedAttribute, allAttributeNames)}
                </span>
            )}
        </>
    );
}

export default FilterSelectionCount;
